export const errorCodes = {
    10010601: {
        description: 'no se recibio el request.',
        message: 'Por favor verifique la documentación ingresada e intente con un documento de menor peso. ',
        type: 'error'
    }, // confirm
    10010201: {
        description: 'No se encontro el usuario en la base de datos.',
        message: 'Por favor verificar las credenciales de acceso Loan ',
        type: 'error'
    }, // putByAttribute person
    10010301: {
        description: 'No se encontro el usuario en la base de datos.',
        message: 'Por favor verificar las credenciales de acceso Loan ',
        type: 'error'
    }, // create person
    605: {
        description: 'La consulta no trajo registros',
        message: '605: No se pudo identificar a la persona. Por favor verfique el número de DNI ingresado.',
        type: 'error'
    },
    1002: {
        description: 'Error externo de la API de Identificar persona bancaria',
        message: '1002: Lo sentimos, existe un inconveniente en el Sistema de identificación. Vuelva a intentar la operación o comuníquese con nuestro Help Desk.',
        type: 'error'
    }

};

export const errorWords = {
    NotFoundBill: {
        code: '00',
        description: 'NotFoundBill',
        message: 'No se encontró una factura cargada.',
        type: 'warning'
    },
    NotSigned: {
        code: '00',
        description: 'NotSigned',
        message: 'Faltan datos biométricos.',
        type: 'warning'
    }
};

// const warningList = {
//     NotFoundBill: 'No se encontró una factura cargada',
//     NotSigned: 'Faltan datos biométricos'
// };

export const errorStrings = [
    {
        code: 10010103,
        description: 'El usuario no está habilitado a entrar en el sistema en este día y horario',
        message: 'Verificar Habilitacion del Usuario en Sistema LOAN ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ObtenerEstadoSolicitud'
    },
    {
        code: 10010203,
        description: 'El usuario no está habilitado a entrar en el sistema en este día y horario',
        message: 'Verificar Habilitacion del Usuario en Sistema LOAN ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010303,
        description: 'El usuario no está habilitado a entrar en el sistema en este día y horario',
        message: 'Verificar Habilitacion del Usuario en Sistema LOAN ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ModificarPersona'
    },
    {
        code: 10010822,
        description: 'NO PUDIMOS IDENTIFICAR AL CLIENTE POR FAVOR VERIFICAR LOS DATOS INGRESADOS',
        message: 'Verificar carga de DNI/SEXO en consulta. ',
        type: 'warning',
        time: 0,
        request: 'api/ecommerce/ValidarCliente'
    },
    {
        code: 10010895,
        description: 'Error de conexion, por favor vuelva a intentar en unos minutos',
        message: 'Error de Conexión Motor - Reintentar en unos minutos. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ValidarCliente'
    },
    {
        code: 10010899,
        description: 'Se produjo un error al consultar el servicio Motor Banco Columbia para el cliente.',
        message: 'Error de Conexión Motor - Reintentar en unos minutos. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ValidarCliente'
    },
    {
        code: 10010604,
        description: 'El usuario está bloqueado',
        message: 'Usuario Loan se encuentra Bloqueado. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/CargarDocumentacionGenerica'
    },
    {
        code: 10010304,
        description: 'El usuario se encuentra bloqueado',
        message: 'Usuario Loan se encuentra Bloqueado. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ModificarPersona'
    },
    {
        code: 10010404,
        description: 'El usuario se encuentra bloqueado',
        message: 'Usuario Loan se encuentra Bloqueado. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ObtenerParametros'
    },
    {
        code: 10010204,
        description: 'El usuario se encuentra bloqueado',
        message: 'Usuario Loan se encuentra Bloqueado. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010315,
        description: 'No se puede modificar la persona porque existe más de una persona con los mismos datos',
        message: 'Cliente Duplicado en Bases Internas Loan. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ModificarPersona'
    },
    {
        code: 10010815,
        description: 'No se puede modificar la persona porque existe más de una persona con los mismos datos',
        message: 'Cliente Duplicado en Bases Internas Loan. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ValidarCliente'
    },
    {
        code: 10010318,
        description: 'Ya existe la Empresa que desea crear',
        message: 'Cliente Duplicado en Bases Internas Loan. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ModificarPersona'
    },
    {
        code: 10010593,
        description: 'System.ArgumentException: División por cero',
        message: 'Verificar parametria Calculador de Cuotas. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: 10010592,
        description: 'System.NullReferenceException: Referencia a objeto no establecida como instancia de un objeto',
        message: 'Verificar parametria Calculador de Cuotas. ',
        type: 'error', /* Several Error */
        time: 0,
        request: '/api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: 10010594,
        description: 'You have an error in your SQL syntax; check the manual that corresponds to your MySQL server version for the right syntax to use near `FROM` at line 1',
        message: 'Verificar parametria Calculador de Cuotas. ',
        type: 'error', /* Several Error */
        time: 0,
        request: '/api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: 10010408,
        description: 'El usuario debe tener un comercio por default configurado',
        message: 'Verificar Parametria Usuario/Comercio. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametros'
    },
    {
        code: 10010508,
        description: 'El usuario debe tener un comercio por default configurado',
        message: 'Verificar Parametria Usuario/Comercio. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: 10010492,
        description: 'System.NullReferenceException: Object reference not set to an instance of an object',
        message: 'Verificar Parametria Usuario/Comercio. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametros'
    },
    {
        code: 10010614,
        description: 'La solicitud ya se encuentra aprobada',
        message: 'La solicitud ya se encuentra aprobada. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/CargarDocumentacionGenerica'
    },
    {
        code: 10010002,
        description: 'No se encontro el usuario en la base de datos', /* TODO no tiene el punto final */
        message: 'Verificar Usuario si esta dado de Alta en LOAN. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/GenerarToken'
    },
    {
        code: 10010201,
        description: 'No se encontro el usuario en la base de datos. Compruebe el uso de mayusculas y minusculas',
        message: 'Verificar clave LOAN. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010202,
        description: 'No se encontro el usuario en la base de datos.',
        message: 'Verificar Usuario Loan. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010301,
        description: 'No se encontro el usuario en la base de datos. Compruebe el uso de mayusculas y minusculas',
        message: 'Verificar clave LOAN. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: 10010302,
        description: 'No se encontro el usuario en la base de datos.',
        message: 'Verificar Usuario Loan. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: 10010710,
        description: 'El Banco  no puede ser nulo', /* misma respuesta */
        message: 'El Banco  no puede ser nulo. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010711,
        description: 'El cbu no puede ser nulo', /* misma respuesta */
        message: 'El cbu no puede ser nulo. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010209,
        description: 'La version del sistema difiere del asentado en base de datos',
        message: 'Verificar Version Sistema Loan. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010712,
        description: 'El Tipo Cuenta Bancaria no puede ser nulo', /* misma respuesta */
        message: 'El Tipo Cuenta Bancaria no puede ser nulo. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010316,
        description: 'Nombre inválido-',
        message: 'Error de formato Nombre. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: 10010713,
        description: 'No se encontraron planes con los datos ingresados',
        message: 'Verificar Parametria Comercio/Planes. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010317,
        description: 'Tipo empleo inválido-',
        message: 'Verificar Cliente - Tipo empleo Invalido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    /* tokens */
    {
        code: 10010205,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010305,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: 10010405,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametros'
    },
    {
        code: 10010505,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: 10010705,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010805,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ValidarCliente'
    },
    {
        code: 10010905,
        description: 'El token provisto no es válido',
        message: 'Token invalido por estar Vencido. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerImpresionSolicitud'
    },
    // {
    //     code: 10010291,
    //     description: '',
    //     message: 'No hay detalle del error proveniente de LOAN. ',
    //     type: 'error', /* Several Error */
    //     request: '/api/ecommerce/ObtenerPersona'
    // },
    // {
    //     code: 10010891,
    //     description: '',
    //     message: 'No hay detalle del error proveniente de LOAN. ',
    //     type: 'error', /* Several Error */
    //     request: '/api/ecommerce/ValidarCliente'
    // },
    /* help desk - Codigo de referencia */
    {
        code: 10010290,
        description: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia:',
        message: 'No se pudo procesar la consulta. Favor de volver a Intentar - Cod de Referencia {nro}. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: 10010390,
        description: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia:',
        message: 'No se pudo procesar la consulta. Favor de volver a Intentar - Cod de Referencia {nro}. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: 10010790,
        description: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia:',
        message: 'No se pudo procesar la consulta. Favor de volver a Intentar - Cod de Referencia {nro}. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ConfirmarOperacion'
    },
    {
        code: 10010890,
        description: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia:',
        message: 'No se pudo procesar la consulta. Favor de volver a Intentar - Cod de Referencia {nro}. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ValidarCliente'
    },
    {
        code: 10010990,
        description: 'Lo sentimos, existe un inconveniente en la aplicación. Vuelva a intentar la operación o comuníquese con nuestro help desk – código de referencia:',
        message: 'No se pudo procesar la consulta. Favor de volver a Intentar - Cod de Referencia {nro}. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/ObtenerImpresionSolicitud'
    },
    /** */
    {
        code: 10010821,
        description: 'EL CLIENTE NO CUMPLE CON POLÍTICAS CREDITICIAS',
        message: 'El cliente no cumple con las políticas crediticias. ',
        type: 'info',
        time: 0,
        request: '/api/ecommerce/ValidarCliente'
    },
    {
        code: 10010820,
        description: 'El cliente no cumple con las políticas crediticias',
        message: 'El cliente no cumple con las políticas crediticias. ',
        type: 'info',
        time: 0,
        request: '/api/ecommerce/ValidarCliente'
    },
    {
        code: 10010601,
        description: 'No se pudo ejecutar el servicio web, no se recibio el request',
        message: 'Por favor verifique la documentación ingresada e intente con un documento de menor peso. ',
        type: 'error',
        time: 0,
        request: '/api/ecommerce/CargarDocumentacionGenerica'
    },
    {
        code: 10010219,
        description: 'El nombre de la persona debe tener el formato Apellido/s,Nombre/s',
        message: 'Verificar formato Apellido,Nombre del solicitante. Volver a cargarlo. ',
        type: 'continue',
        time: 0,
        request: '/api/ecommerce/ObtenerParametros'
    },
    {
        code: '00550219',
        description: 'Not found person with document',
        message: '',
        type: 'continue',
        time: 1,
        request: '/api/ecommerce/ObtenerPersona'
    },
    {
        code: '00550319',
        description: 'Not found person with document',
        message: '',
        type: 'continue',
        time: 0,
        request: '/api/ecommerce/ModificarPersona'
    },
    {
        code: '00489901',
        description: 'Not found Loan credentials for user',
        message: 'Configurar cuenta LOAN en BackOffice Cuotitas, id de usuario: {nro}. ',
        type: 'error',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '0099',
        description: 'Not found sign request',
        message: 'No se encontró la solicitud de préstamo seleccionada. Por favor actualizar la página. ',
        type: 'error',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '00552501',
        description: 'Provider could not send notification to:',
        message: 'Error de envío de OTP. Por favor volver a intentar. ',
        type: 'error',
        time: 0,
        request: 'cuotitasstores/device/verify'
    },
    {
        code: '10011001',
        description: 'El telefono celular se encuentra registrado para otro usuario',
        message: 'El celular se encuentra registrado en otro cliente, por favor verificar el número ingresado .',
        type: 'warning',
        time: 5000,
        request: 'apicuotitas/validartelefonocelularrepetido'
    },
    {
        code: 'EXT01XXX001',
        description: 'No installments available',
        message: 'Lo sentimos, la politica seleccionada no posee plan de cuotas asociado. Comuníquese con nuestro help desk - Código de politica: {nro}. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/ObtenerParametrosCuotas'
    },
    {
        code: '',
        description: 'The user is not authorized to perform this task',
        message: 'Verificar Habilitación del Usuario Cuota Ya en BackOffice Cuotitas. ',
        type: 'error',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '',
        description: 'is not active',
        message: 'Verificar Habilitación del Usuario Cuota Ya en BackOffice Cuotitas. ',
        type: 'error',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '',
        description: 'Provider returned invalid state',
        message: 'Lo sentimos, su solicitud no pudo ser procesada correctamente en LOAN, el sistema retorna IdSolicitud = 0, genere un nuevo préstamo. ',
        type: 'error',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '',
        description: 'The PDF has wrong number of pages expected.',
        message: 'El contrato entregado por LOAN no es un contrato válido, comuníquese con Help Desk. ',
        type: 'error',
        time: 0,
        request: 'ctech /signs/finket/cuotitas/divide'
    },
    {
        code: '',
        description: 'User is not allowed to use this store',
        message: 'Su usuario tiene datos desactualizados. Por favor recargue la pantalla y vuelva a intentar.',
        type: 'warning',
        time: 0,
        request: 'ctech*'
    },
    {
        code: '',
        description: 'Timeout Error. Try again later',
        message: 'El tiempo de espera para la respuesta del Motor superó al establecido - Reintentar en unos minutos. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/*'
    },
    {
        code: '',
        description: 'Unauthorized. Store is not avalilable',
        message: 'El usuario debe tener un comercio habilitado en BackOffice. Comuníquese con nuestro help desk. ',
        type: 'error',
        time: 0,
        request: 'api/ecommerce/*'
    }
];

/*
api/ecommerce/ObtenerPersona
api/ecommerce/ModificarPersona
api/ecommerce/ObtenerParametros
"1 /api/ecommerce/ObtenerPersona (sólo para tener el id persona externa)
2 api/ecommerce/ValidarCliente"
/api/ecommerce/ObtenerParametrosCuotas
api/ecommerce/ModificarPersona
api/ecommerce/ConfirmarOperacion
/api/ecommerce/ObtenerImpresionSolicitud
*/
